import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Suites from "@/pages/Suites";
import SuiteDetail from "@/pages/SuiteDetail";
import History from "@/pages/History";
import Experiences from "@/pages/Experiences";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import GuiaHospede from "@/pages/GuiaHospede";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import PageViewTracker from "@/components/PageViewTracker";
import CookieBanner from "@/components/CookieBanner";

const STANDALONE_ROUTES = ["/guia-hospede"];

function AppContent() {
  const location = useLocation();
  const isStandalone = STANDALONE_ROUTES.includes(location.pathname);

  return (
      <div className="App">
          <ScrollToTop />
          <PageViewTracker />
          {!isStandalone && <Navbar />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/suites" element={<Suites />} />
            <Route path="/suite/:id" element={<SuiteDetail />} />
            <Route path="/historia" element={<History />} />
            <Route path="/experiencias" element={<Experiences />} />
            <Route path="/galeria" element={<Gallery />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/guia-hospede" element={<GuiaHospede />} />

          </Routes>
          {!isStandalone && <Footer />}
          <CookieBanner />
        </div>
    );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppContent />        
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
